import { supabase } from './supabase'

let _userId = null

export function setLogUser(userId) {
  _userId = userId
}

export async function log(acao, entidade, entidade_id, detalhe = {}) {
  if (!_userId) return
  try {
    const { error } = await supabase.from('logs').insert({
      user_id: _userId,
      acao,
      entidade,
      entidade_id: entidade_id != null ? String(entidade_id) : null,
      detalhe,
    })
    if (error) console.error('[log]', acao, error)
  } catch (e) {
    console.error('[log] exception:', acao, e)
  }
}
